<template src="../templates/help.html">

</template>


<script>
    export default {
        name: "HelpComponent"
    }
</script>

<style scoped>
    .cardStyle {
        min-height: 300px;
    }
</style>


// WEBPACK FOOTER //
// src/components/HelpComponent.vue